/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 //If you got "$ is not defined" error in console then put this code in your theme.js file
  $('.accordion-toggle').click(function(){
    $(this).next().toggleClass("open");
    $(this).find('i').toggleClass('fa-angle-down');
    $(this).find('i').toggleClass('fa-angle-up');
  });

document.querySelectorAll('.ColorSwatch__Radio').forEach(
  (input) => input.addEventListener('click', this.onButtonClick.bind(this))
);
function onButtonClick(event) {
  event.preventDefault();
  
  const idForm = event.target.dataset.productFormId;
  const idVariant = event.target.dataset.variantId;
  document.getElementById(idForm).value = idVariant;
}

function _addMeToCart(e, el) {
  e = e || window.event;
  e.preventDefault();

  let formData = {
    'items': [
      {
        'id': el.dataset.variant_id,
        'quantity': 1
      }
    ]
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then((resp) => {
    return resp.json();
  })
  .then((data) => {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true
  }));
  })
  .catch((err) => {
    console.error('Error: ' + err);
  })
}

